import { InputText } from "primereact/inputtext";
import localeText from "../../../locale";

const EmailField = ({ email, setEmail, emailRef, onBlurEmail, loading }) => {
  return (
    <div className="w-full">
      <label className="font-semibold text-sm" htmlFor="email" style={{ color: "#0D0D0E" }}>
        E-mail
      </label>
      <div className="mt-2">
        <InputText
          ref={emailRef}
          name="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onFocus={() => {
            if (emailRef.current) emailRef.current.style.border = "1px solid #ced4da";
          }}
          onBlur={onBlurEmail}
          className="w-full p-3"
          placeholder={localeText("enterEmail")}
          disabled={loading}
        />
      </div>
    </div>
  );
};

export default EmailField;

